import { lazy, Suspense, type ReactNode } from 'react';
import { usePrefersReducedMotion } from '@/hooks/usePrefersReducedMotion';

interface Props {
  pathKey: string;
  children: ReactNode;
}

const MotionTransition = lazy(async () => {
  const { AnimatePresence, motion } = await import('framer-motion');
  return {
    default: ({ pathKey, children }: Props) => (
      <AnimatePresence mode="wait" initial={false}>
        <motion.div
          key={pathKey}
          initial={{ opacity: 0, y: 6 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.18, ease: 'easeOut' }}
        >
          {children}
        </motion.div>
      </AnimatePresence>
    ),
  };
});

export function PageTransition({ pathKey, children }: Props) {
  const reduced = usePrefersReducedMotion();
  if (reduced) return <>{children}</>;
  return (
    <Suspense fallback={<>{children}</>}>
      <MotionTransition pathKey={pathKey}>{children}</MotionTransition>
    </Suspense>
  );
}
